// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"8380dc82f573a02072c0","133":"f0071f54456841400bfc","134":"f6c6b8ba053e6edee603","181":"171bf9ca1c0acc7f522c"}[chunkId] + ".chunk.js";
};